import { Button } from 'react-bootstrap';

const VideoControlButton = ({
  ariaControls,
  ariaLabel,
  ariaPressed,
  children,
  className = 'p-0',
  disabled,
  onClick,
  title,
}) => {
  return (
    <Button
      variant="dark"
      className={`vms-video-control-button d-inline-flex align-items-center justify-content-center lh-1 ${className}`}
      title={title}
      aria-controls={ariaControls}
      aria-label={ariaLabel || title}
      aria-pressed={typeof ariaPressed === 'boolean' ? ariaPressed : undefined}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </Button>
  );
};

export default VideoControlButton;
